import {get} from 'lodash-es';
import {useEffect, useState} from 'react';

import {IFieldAvailabilityCondition} from 'entities/metadata';

export const useFieldAvailability = (
    fieldNonAvailabilityConditions: IFieldAvailabilityCondition[],
    formValues?: any,
) => {
    const [available, setIsAvailable] = useState(true);

    useEffect(() => {
        fieldNonAvailabilityConditions.forEach(condition => {
            if (condition.fieldValues.includes(get(formValues, condition.fieldName))) {
                setIsAvailable(false);
            }
        });
    }, [formValues, fieldNonAvailabilityConditions]);
    return {available};
};
